import { createAffiliateUri, getPotentialGAMClickTracker, parseMarkup } from '../../../utils/index.js';
import { walmartConfig as config } from '../data/index.js';
/**
 * `walmartCheckout` is the {@link ICheckoutService} for
 * the Walmart retailer integration
 */
const walmartCheckout = {
    config,
    /**
     * `checkout` executes the walmart-specific functionality to purchase products
     * @param {IRetailerCartItem[]} items - the {@link IRetailerCartItem} array of products to be purchased
     * @param {IRetailerLocation} location - the currently selected {@link IRetailerLocation}
     * @param {IImpactRadius} impactRadiusTracking - object of Impact Radius affiliate tracking values to be appended to the checkout URL
     */
    checkout: (walmartCheckoutServiceConfig) => {
        const checkoutUrl = new URL(createAffiliateUri(config.baseURI, walmartCheckoutServiceConfig.impactRadius?.subId1, walmartCheckoutServiceConfig.impactRadius?.subId2, walmartCheckoutServiceConfig.impactRadius?.subId3, walmartCheckoutServiceConfig.impactRadius?.sharedId));
        const itemString = walmartCheckoutServiceConfig.selectedItems
            .map((item) => item.id)
            .join(',');
        const affiliate = parseMarkup(config.affiliateURI, walmartCheckoutServiceConfig.location ? walmartCheckoutServiceConfig.location : {}) +
            itemString;
        checkoutUrl.searchParams.append('u', affiliate);
        if (!walmartCheckoutServiceConfig.location) {
            const walmartCheckoutUrlWithoutStoreId = new URL(affiliate);
            walmartCheckoutUrlWithoutStoreId.searchParams.delete('storeId');
            checkoutUrl.searchParams.set('u', walmartCheckoutUrlWithoutStoreId.toString());
            console.log(walmartCheckoutUrlWithoutStoreId.toString());
        }
        const gamRedirectUrl = getPotentialGAMClickTracker();
        let destinationUrl = checkoutUrl.toString();
        if (window.location.hostname === 'localhost' && gamRedirectUrl) {
            // URI needs to be encoded on localHost ONLY for testing purposes
            destinationUrl = encodeURIComponent(destinationUrl);
        }
        const retailerCheckoutUrl = gamRedirectUrl ? `${gamRedirectUrl}${destinationUrl}` : destinationUrl;
        //console.log("Walmart Checkout URL:", retailerCheckoutUrl);
        // Open checkout URL in new tab
        window.open(retailerCheckoutUrl, '_blank');
        // And return the value so we can use it in telemetry of the parent application
        return retailerCheckoutUrl;
    }
};
export default walmartCheckout;
